import { FC, useMemo } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { PageType } from "../../types/ui";
import { TranslationKey } from "../../utils/translations";
import ContactUsButton from "../ContactUsButton";
import { Root, Content, Title, Body } from "./styles";

interface Props {
  type: PageType;
  color: string;
}

const ContactUs: FC<Props> = ({ type, color }) => {
  const { t } = useTranslation();

  const texts = useMemo(() => {
    const textMap: { [key in PageType]: { title: TranslationKey; body: TranslationKey } } = {
      contact: {
        title: "footerContactUsTitle",
        body: "footerContactUsDescription",
      },
      license: {
        title: "footerLicenseIndex",
        body: "footerLicenseIndexDescription",
      },
      product: {
        title: "footerEnhanceProduct",
        body: "footerEnhanceProductDescription",
      },
      license_index: {
        title: "footerLicenseBestInClass",
        body: "footerLicenseBestInClassDescription",
      },
      thematic: {
        title: "footerUnlockPotential",
        body: "footerUnlockPotentialDescription",
      },
      start: {
        title: "footerGetStarted",
        body: "footerGetStartedDescription",
      },
      technology: {
        title: "footerContactUsTech",
        body: "footerContactUsTechDescription",
      },
      ready_to_get_started: {
        title: "footerReadyToGetStarted",
        body: "footerReadyToGetStartedDescription",
      },
    };

    return {
      title: t(textMap[type].title),
      body: t(textMap[type].body),
    };
  }, [type, t]);

  return (
    <Root>
      <Content>
        <Title>{texts.title}</Title>
        <Body>{texts.body}</Body>
        <ContactUsButton color={color} />
      </Content>
    </Root>
  );
};

export default ContactUs;
